import React, { Suspense } from "react";
import { Skeleton } from "antd";
import { OrganizationsPage } from '@rankmi/ats-app'

const LandingPage = ({ organizationSlug, organizationToken, tenantId }) => {
  const skeleton = () => {
    return (
      <Skeleton
        title={true}
        active={true}
        paragraph={{ rows: 6 }}
      />
    );
  };

  return (
    <Suspense fallback={skeleton()}>
      <div className="organization-page-container">
      <OrganizationsPage
        tenantId={tenantId}
        organizationSlug={organizationSlug}
        organizationToken={organizationToken}
      />
      </div>
    </Suspense>
  );
};

export default LandingPage;
